import { useTranslation } from "react-i18next";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Typography,
} from "@mui/material";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";

export interface QuickActionsSubscribeDialogProps {
    open: boolean;
    isSubscribed: boolean;
    handleClose: () => void;
    handleSuccess: () => void;
    quickActionTitle?: string;
}

export const QuickActionsSubscribeDialog = (props: QuickActionsSubscribeDialogProps) => {
    const { open, isSubscribed, handleClose, handleSuccess, quickActionTitle } = props;
    const { t } = useTranslation();

    return (
        <Dialog maxWidth={'sm'}
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <Box sx={{ textAlign: "center" }}>
                    <GppMaybeIcon sx={{ fontSize: 72 }} color="info" />
                </Box>
                <DialogContentText id="alert-dialog-description">
                    <Typography variant="body1">
                        {isSubscribed
                            ? t(
                                'Are you sure you want to unsubscribe to "{{quickActionTitle}}"? This preference can also be toggled in your profile.',
                                { quickActionTitle }
                            ) : t(
                                'Are you sure you want to subscribe to "{{quickActionTitle}}"? This preference can also be toggled in your profile.',
                                { quickActionTitle }
                            )}
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                    color="primary"
                    variant="outlined"
                >
                    {t("Cancel")}
                </Button>                
                <Button
                    data-cy-id={'quick_actions_subscribe_submit_btn'}
                    onClick={() => handleSuccess()}
                    autoFocus
                    color={isSubscribed ? "error" : "primary"}
                    variant="contained"
                >
                    {isSubscribed
                        ? t("Unsubscribe")
                        : t("Subscribe")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
